import { Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";
import { AdminGuard } from "./shared/guard/admin.guard";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "pages/lista-utenti",
    pathMatch: "full",
  },
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "auth/reset-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "",
    redirectTo: "pages/dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: ContentComponent,
    children: content,
    canActivate: [AdminGuard],
  },
];
